import React, { useContext } from 'react';
import { displayMessage } from '../services/helper';
import Button from '../components/buttons/Button';
import PatientInfo from '../components/infos/PatientInfo';
import styles from '../services/styles';
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import { useNavigate } from 'react-router-dom';

const { tc2 } = styles;

export default function Home() {
    const { mobile_mode } = useContext(GeneralContext)
    const navigate = useNavigate()
    return (
        <div className='w-full h-full flex flex-col'>
            <div>
                <PatientInfo />
            </div>
            <div className={`flex ${mobile_mode ? 'p-5 gap-5' : 'gap-20 p-10'} h-full ${mobile_mode && 'flex-col'}`}>
                <Button
                    className='w-full h-full font-bold text-lg text-white rounded-3xl max-h-[335px]'
                    style={{
                        backgroundColor: tc2,
                        boxShadow: '2px 4px 7px 2px rgba(0, 0, 0, 0.5)',
                        cursor: 'pointer',
                        transition: 'background-color 0.3s ease',
                    }}
                    onClick={() => navigate('./monitory')}
                >
                    {displayMessage('START', [displayMessage('MONITORY')])}
                </Button>
                <Button
                    className='w-full h-full font-bold text-lg text-white rounded-3xl max-h-[335px]'
                    style={{
                        backgroundColor: tc2,
                        boxShadow: '2px 4px 7px 2px rgba(0, 0, 0, 0.5)',
                        cursor: 'pointer',
                        transition: 'background-color 0.3s ease',
                    }}
                    onClick={() => navigate('./exercise')}
                >
                    {displayMessage('START', [displayMessage('EXERCISES')])}
                </Button>
            </div>
        </div>
    );
}
